import { z } from "zod";
import { common } from "../common";
import { stepGetBaseSchema } from "./stepGetBaseSchema";
import { triggerGetSchema } from "../trigger/triggerGetSchema";

export const actionPathGetSchema = z.object({
  id: common.objectId,
  name: z.string().nullable(), // null: 30 (0.02%)
  exits_canvas: z.boolean().nullable(), // null: 574 (0.31%)
  next_step_id: common.objectId.nullable(),
  trigger_events: triggerGetSchema.nullable(),
});

export const actionPathsStepGetSchema = z.object({
  ...stepGetBaseSchema.shape,
  type: z.literal("ACTION_PATHS"),
  step_data: z.object({
    action_paths: z.array(actionPathGetSchema),
    advance_immediately: z.boolean().nullable(), // null: 15_359 (10.01%)
    duration_in_seconds: z.int().nullable(), // null: 92 (0.06%)
    everyone_else_exits_canvas: z.boolean().nullable(), // null: 217 (0.14%)
    has_ranked_order: z.boolean().nullable(), // null: 15_084 (9.83%)
  }),
});
